
const EVOLUTION_SPORT_NAME = "EVOLUTION SPORT";

// Classes available for each tier at EVOLUTION SPORT
// Keywords to match against class titles (case-insensitive)
const SILVER_CLASSES = [
  "musculación", "musculacion", "cardio",
  "funcional", "indoor", "stretching",
];

const GOLD_AND_ABOVE_CLASSES = [
  ...SILVER_CLASSES,
  "zumba", "tela", "power core",
  "boxeo", "kick", "taekwondo", "jujutsu", "jiu", "bjj",
  "crossfit", "cross fit",
];

const TIER_HIERARCHY: Record<string, string[]> = {
  SILVER: SILVER_CLASSES,
  GOLD: GOLD_AND_ABOVE_CLASSES,
  PLATINUM: GOLD_AND_ABOVE_CLASSES,
  BLACK: GOLD_AND_ABOVE_CLASSES,
};

function classMatchesKeywords(title: string, keywords: string[]): boolean {
  const normalizedTitle = title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return keywords.some(keyword => {
    const normalizedKeyword = keyword.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalizedTitle.includes(normalizedKeyword);
  });
}

export function filterClassesByTier<T extends { title: string }>(
  classes: T[],
  tier: string | undefined,
  gymName: string | undefined
): T[] {
  // Only apply filtering for EVOLUTION SPORT
  if (!gymName || gymName.toUpperCase() !== EVOLUTION_SPORT_NAME) {
    return classes;
  }

  // Determine allowed keywords based on tier
  const allowedKeywords = tier ? TIER_HIERARCHY[tier.toUpperCase()] : SILVER_CLASSES;

  if (!allowedKeywords) {
    // Unknown tier - allow basic classes only
    return classes.filter(c => classMatchesKeywords(c.title, SILVER_CLASSES));
  }

  return classes.filter(c => classMatchesKeywords(c.title, allowedKeywords));
}
